module.exports = __webpack_public_path__ + "0ccf6b1a4307e24798df6080001939bd.MP3";